import { getDeviceSchema, SIP_GATEWAY } from "callable-data-objects";
import FormSubmit from "Components/Shared/FormSubmit";
import SipTrunkSelect from "Components/Shared/SipTrunkSelect";
import { Formik } from "formik";
import { useDevice } from "Hooks/Endpoints";
import React, { Fragment } from "react";
import { Form } from "semantic-ui-react";

const SipGatewayEdit = () => {
  const { account, update, device } = useDevice();

  if (!device) return <Fragment />;

  return (
    <Formik
      initialValues={device}
      validationSchema={getDeviceSchema(SIP_GATEWAY)}
      onSubmit={(values, actions) => {
        update(values);
      }}
    >
      {(props) => (
        <Form onSubmit={props.handleSubmit}>
          <SipTrunkSelect
            name='sipGateway.trunks'
            label='Trunks'
            trunks={account.trunks}
          />
          <FormSubmit name='Update Trunks' errors={props.errors} />
        </Form>
      )}
    </Formik>
  );
};

export default SipGatewayEdit;
